
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/maps/[slug]",
      function () {
        return require("private-next-pages/maps/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/maps/[slug]"])
      });
    }
  